import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  id?: string;
  size?: 'lg' | 'md';
  shake?: boolean;
};
export function CtaButton({
  label,
  id,
  size = 'lg',
  shake = false
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'min-h-[68px] px-6 py-4 text-[17px] sm:text-xl' : 'min-h-[56px] px-5 py-3 text-base sm:text-lg';
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-gold text-center font-extrabold uppercase leading-tight tracking-wide text-ink shadow-[0_6px_0_#B88E00] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-gold-deep active:translate-y-[4px] active:shadow-[0_2px_0_#B88E00] focus:outline-none focus-visible:ring-4 focus-visible:ring-ink/30 ${sizing} ${shake ? 'animate-cta-shake' : ''}`} data-id="element-12" data-mp="qir03e5toqrl">
      <span data-id="element-13" data-mp="157dcp842f4f4">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-14" data-mp="35x5y7jbaqy4l" />
    </a>;
}